import { Pipe, PipeTransform } from '@angular/core';
import { AirlinePreference } from '@ag-common-lib/lib/models/utils/flight-preference.model';

@Pipe({ name: 'isSecondChoiceSelected' })
export class IsSecondChoiceSelectedPipe implements PipeTransform {
  transform(data: Partial<AirlinePreference>, airlinePreferences: AirlinePreference[]): boolean {
    // Disable "2nd choice" for the current airline if another airline is already selected as 2nd choice.
    return airlinePreferences.some(
      airline => airline.isSecondChoiceAirline && airline.airline !== data.airline,
    );
  }
}
